import { Link } from "@tanstack/react-router";
import { buildCityLinkSearch } from "~/lib/search/cms-location-catalog";
import { withLocale } from "~/lib/utils/with-locale";

export const CITY_LINK_ITEMS: ReadonlyArray<{
  label: string;
  locationType?: number;
  occasion?: number;
}> = [
  { label: "Eventlocation", locationType: 3 },
  { label: "Hochzeitslocation", locationType: 11 },
  { label: "Veranstaltungsraum", locationType: 4 },
  { label: "Tagungsraum", locationType: 9 },
  { label: "Seminarraum", locationType: 10 },
  { label: "Konferenzraum", locationType: 9 },
  { label: "Veranstaltungslocation", locationType: 3 },
  { label: "Partylocation", locationType: 2 },
  { label: "Eventraum", locationType: 3 },
  { label: "Feierlocation", occasion: 2 },
  { label: "Location mieten" },
  { label: "Hochzeitsfeier", locationType: 11 },
  { label: "Firmenevent Location", locationType: 3 },
  { label: "Geburtstagslocation", occasion: 2 },
  { label: "Business Event Location", locationType: 3 },
  { label: "Meetingraum", locationType: 10 },
  { label: "Kongresszentrum", locationType: 9 },
  { label: "Tagungshotel", locationType: 1 },
  { label: "Location für Feier", occasion: 2 },
  { label: "Räumlichkeiten mieten" },
];

interface CityLinksProps {
  cities: string[];
}

export default function CityLinks({ cities = [] }: CityLinksProps) {
  return (
    <div className="bg-[#060606] layout-place-full-width py-10 md:py-20">
      <div className="layout-content-grid layout-place-full-width">
        <div className="w-full grid gap-10 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {cities.map((city) => (
            <div key={city} className="flex flex-col gap-1">
              <h2 className="font-semibold text-white ">Locations in {city}</h2>
              <div className="flex flex-col gap-1 mt-2">
                {CITY_LINK_ITEMS.map((item) => (
                  <Link
                    key={`${item.label}-${item.locationType ?? ""}-${item.occasion ?? ""}`}
                    to={withLocale("/search")}
                    search={buildCityLinkSearch(city, {
                      locationType: item.locationType,
                      occasion: item.occasion,
                    })}
                    className="text-sm w-fit text-white hover:text-dove-gray-light transition"
                  >
                    {item.label} {city}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
